import { AccountClockIcon } from './AccountClockIcon';

/**
 * author: Coffeemate
 * id E9851E02-790A-40FD-918A-BB1145051470
 * name account-clock
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-clock.svg
 * tags
 * - Account / User 
 * - Date / Time 
 */
export const PersonClockIcon = AccountClockIcon;
export default PersonClockIcon